// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_infoBar__31\\+R0 {
  background: #f5f7fa;
  border-radius: 12px;
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  margin-bottom: 16px;
  padding: 16px 20px;
}

.styles_infoLabel__zNdO9 {
  color: #6b7280;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.styles_infoValue__qVndK {
  color: #1f2937;
  font-size: 0.9375rem;
  font-weight: 600;
  margin-top: 2px;
}

.styles_banner__APqQz {
  align-items: center;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px 16px;
}

.styles_bannerEnviado__U2N7z {
  background: #e3f2fd;
  color: #0d47a1;
}

.styles_bannerAprovado__Gggqg {
  background: #e8f5e9;
  color: #1b5e20;
}

.styles_bannerCancelado__FKLl6 {
  background: #eceff1;
  color: #37474f;
}

.styles_bannerData__Uea02 {
  font-size: 0.8125rem;
  margin-left: auto;
  opacity: 0.85;
}

.styles_cards__oNSJ8 {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  margin-bottom: 16px;
}

.styles_card__Jq9zA {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px 20px;
}

.styles_cardDestaque__iO2gw {
  background: linear-gradient(135deg, #18316e 0%, #2a4a9a 100%);
  border: none;
  color: #ffffff;
}

.styles_cardLabel__sYXqj {
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.styles_cardValor__SGjfb {
  font-size: 1.5rem;
  font-weight: 700;
  margin-top: 4px;
}

.styles_cardLinha__VImT3 {
  display: flex;
  font-size: 0.875rem;
  justify-content: space-between;
  margin-top: 8px;
}

.styles_cardLinhaTotal__A2IAa {
  border-top: 1px solid #e0e0e0;
  font-weight: 700;
  margin-top: 12px;
  padding-top: 10px;
}

.styles_tableWrap__z\\+m7E {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  overflow-x: auto;
}

.styles_table__pfENb {
  border-collapse: collapse;
  width: 100%;
}

.styles_table__pfENb th {
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
  color: #424242;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.4px;
  padding: 10px 14px;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}

.styles_table__pfENb td {
  border-bottom: 1px solid #f0f0f0;
  color: #424242;
  font-size: 0.875rem;
  padding: 10px 14px;
}

.styles_table__pfENb tfoot td {
  background: #fafafa;
  font-weight: 700;
}

.styles_direita__A0sDI {
  text-align: right !important;
}

.styles_tipoBadge__rIfpa {
  border-radius: 20px;
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 3px 10px;
}

.styles_tipoAdministrativo__ai6cw {
  background: #e3f2fd;
  color: #0d47a1;
}

.styles_tipoJudicial__RyMKi {
  background: #f3e5f5;
  color: #6a1b9a;
}

.styles_creditos__8UWXu {
  margin-top: 8px;
}

.styles_creditoErro__6gzrX {
  color: #c62828;
}

`, "",{"version":3,"sources":["webpack://./src/pages/ProjetosApuracao/Resumo/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".infoBar {\n  background: #f5f7fa;\n  border-radius: 12px;\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  margin-bottom: 16px;\n  padding: 16px 20px;\n}\n\n.infoLabel {\n  color: #6b7280;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n}\n\n.infoValue {\n  color: #1f2937;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  margin-top: 2px;\n}\n\n.banner {\n  align-items: center;\n  border-radius: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding: 12px 16px;\n}\n\n.bannerEnviado {\n  background: #e3f2fd;\n  color: #0d47a1;\n}\n\n.bannerAprovado {\n  background: #e8f5e9;\n  color: #1b5e20;\n}\n\n.bannerCancelado {\n  background: #eceff1;\n  color: #37474f;\n}\n\n.bannerData {\n  font-size: 0.8125rem;\n  margin-left: auto;\n  opacity: 0.85;\n}\n\n.cards {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  margin-bottom: 16px;\n}\n\n.card {\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  padding: 16px 20px;\n}\n\n.cardDestaque {\n  background: linear-gradient(135deg, #18316e 0%, #2a4a9a 100%);\n  border: none;\n  color: #ffffff;\n}\n\n.cardLabel {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n}\n\n.cardValor {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-top: 4px;\n}\n\n.cardLinha {\n  display: flex;\n  font-size: 0.875rem;\n  justify-content: space-between;\n  margin-top: 8px;\n}\n\n.cardLinhaTotal {\n  border-top: 1px solid #e0e0e0;\n  font-weight: 700;\n  margin-top: 12px;\n  padding-top: 10px;\n}\n\n.tableWrap {\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  overflow-x: auto;\n}\n\n.table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.table th {\n  background: #fafafa;\n  border-bottom: 1px solid #e0e0e0;\n  color: #424242;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  padding: 10px 14px;\n  text-align: left;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.table td {\n  border-bottom: 1px solid #f0f0f0;\n  color: #424242;\n  font-size: 0.875rem;\n  padding: 10px 14px;\n}\n\n.table tfoot td {\n  background: #fafafa;\n  font-weight: 700;\n}\n\n.direita {\n  text-align: right !important;\n}\n\n.tipoBadge {\n  border-radius: 20px;\n  display: inline-block;\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 3px 10px;\n}\n\n.tipoAdministrativo {\n  background: #e3f2fd;\n  color: #0d47a1;\n}\n\n.tipoJudicial {\n  background: #f3e5f5;\n  color: #6a1b9a;\n}\n\n.creditos {\n  margin-top: 8px;\n}\n\n.creditoErro {\n  color: #c62828;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoBar": `styles_infoBar__31+R0`,
	"infoLabel": `styles_infoLabel__zNdO9`,
	"infoValue": `styles_infoValue__qVndK`,
	"banner": `styles_banner__APqQz`,
	"bannerEnviado": `styles_bannerEnviado__U2N7z`,
	"bannerAprovado": `styles_bannerAprovado__Gggqg`,
	"bannerCancelado": `styles_bannerCancelado__FKLl6`,
	"bannerData": `styles_bannerData__Uea02`,
	"cards": `styles_cards__oNSJ8`,
	"card": `styles_card__Jq9zA`,
	"cardDestaque": `styles_cardDestaque__iO2gw`,
	"cardLabel": `styles_cardLabel__sYXqj`,
	"cardValor": `styles_cardValor__SGjfb`,
	"cardLinha": `styles_cardLinha__VImT3`,
	"cardLinhaTotal": `styles_cardLinhaTotal__A2IAa`,
	"tableWrap": `styles_tableWrap__z+m7E`,
	"table": `styles_table__pfENb`,
	"direita": `styles_direita__A0sDI`,
	"tipoBadge": `styles_tipoBadge__rIfpa`,
	"tipoAdministrativo": `styles_tipoAdministrativo__ai6cw`,
	"tipoJudicial": `styles_tipoJudicial__RyMKi`,
	"creditos": `styles_creditos__8UWXu`,
	"creditoErro": `styles_creditoErro__6gzrX`
};
export default ___CSS_LOADER_EXPORT___;
